<template>
  <div class="shiftdrop-menu-wrp">
    <span class="shift-opener text-capitalize" ><i class="ico ico-fill-circle" :style="{'color':jobRoleColor}"></i>{{ selectedShiftLabel }}</span>
    <ul class="shiftdrop-list">
      <li class="text-capitalize" @click="filterJobRoleFunction('0', 'All Shift','')">
        <span style="background:#989898" class="bg-role"></span><i class="ico ico-fill-circle" ></i><span>All Shift</span>
      </li>
      <li class="text-capitalize" @click="filterJobRoleFunction('available_1', 'Available Shift','')">
        <span style="background:#989898" class="bg-role"></span><i class="ico ico-fill-circle" ></i><span>Available Shift</span>
      </li>
      <li class="text-capitalize" @click="filterJobRoleFunction('on_duty_1', 'On Duty','')">
        <span style="background:#989898" class="bg-role"></span><i class="ico ico-fill-circle" ></i><span>On Duty</span>
      </li>
      <li class="text-capitalize" v-model="selectedShift" v-for="(value,key) in jobTypes" :data-label="value.name" @click="filterJobRoleFunction(value.id, value.name,value.color)">
        <span class="bg-role" :style="{'background':value.color}"></span> <i class="ico ico-fill-circle"  :style="'color:'+value.color"></i><span>{{ value.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";

export default {
  name: 'jobRole',
  components: {},
  props:["jobTypes"],
  data() {
    return{
      selectedShift: 0,
      selectedShiftLabel: 'All Shift',
      jobRoleColor:''
    }
  },
  methods:{
    created() {
    },
    filterJobRoleFunction(id,name,color) {
      this.selectedShiftLabel=name;
      this.jobRoleColor=color;
      this.$emit('selectedShift',id)
    },
  }
}
</script>
